import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import { StoreTypename } from 'types';
import GET_FILTERS from '../../queries/resources/get-filters-query';

export type ResourceFiltersState = {
  filters: any;
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type ResourceFiltersStoreDispatch = undefined;
export type ResourceFiltersStore = [ResourceFiltersState, ResourceFiltersStoreDispatch];

export const getDefaultResourceFiltersState = (): { __typename: string } => ({
  __typename: StoreTypename.RESOURCE_FILTERS,
});

const useResourceFiltersStore = (): ResourceFiltersStore => {
  const { data, loading, error }: QueryResult<{ resourceFilters: any[] }> = useQuery(
    GET_FILTERS,
    {}
  );

  return [
    {
      filters: data?.resourceFilters || [],
      error,
      isLoading: loading,
    },
    undefined,
  ];
};

export default useResourceFiltersStore;
